import { cn } from '@up2stay/up2promo-ui';
import type { ReactNode } from 'react';

export type ListPageBodyProps = {
  children: ReactNode;
  className?: string;
};

/**
 * Standard body under PageHeader for resource list pages.
 * Profiles composition: gap-4 / md:gap-5 stack rhythm.
 */
export function ListPageBody({ children, className }: ListPageBodyProps) {
  return (
    <div
      className={cn('flex min-w-0 flex-1 flex-col gap-4 md:gap-5', className)}
    >
      {children}
    </div>
  );
}
